// packages/hooks/useCategories.ts (ou dans ton app)
"use client"
import { categoryService } from "@cabukaka/services";
import { Category, PaginatedResponse, QueryFilters } from "@cabukaka/types";
import { useData } from "../core/useData";
import { useCallback, useEffect, useState } from "react";

export function useCategories(initialFilters?: QueryFilters) {
    // 1. On utilise le hook générique pour le gros du travail
    const {
        data: categories,
        loading,
        error,
        refresh,
        deleteItem,
        updateItem,
        deleteManyItems
    } = useData<Category>({
        ...categoryService,
        ...categoryService.baseService
    }, initialFilters);



    return {
        categories,
        loading,
        error,
        refresh,
        deleteCategory: deleteItem,
        updateCategory: updateItem,
        deleteManyCategories: deleteManyItems
    };
}

export function useFeaturedCategories() {
    const [featuredCategories, setFeaturedCategories] = useState<Category[]>([]);
    const [total, setTotal] = useState(0);
    const [pages, setPages] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<any>(null);




    const refresh = useCallback(async () => {

        setLoading(true);
        try {
            const res = await categoryService.getFeaturedCategories()


            setFeaturedCategories(res.data);
            setTotal(res.total);
            setPages(res.pages);
            setError(null);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    }, []);


    useEffect(() => {
        refresh();
    }, [refresh]);

    return {
        featuredCategories,
        total,
        pages,
        loading,
        error,
        count: featuredCategories.length,
        refresh,

    };
}